import { render } from "./SalonImgSlider.vue?vue&type=template&id=1661d455&scoped=true"
import script from "./SalonImgSlider.vue?vue&type=script&lang=js"
export * from "./SalonImgSlider.vue?vue&type=script&lang=js"

import "./SalonImgSlider.vue?vue&type=style&index=0&id=1661d455&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1661d455"]])

export default __exports__